import { useOutletContext } from 'react-router-dom'

import { ReadReportsSharePoliciesDocument } from 'generated/resources/graphql'

import type { Back } from 'modules/core/components/Card/types'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import DashboardShow from 'modules/reports/components/DashboardShow'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const DashboardShowPage = () => {
  const { navigation } = useNavigation()

  const { dashboard, loading: loadingContext } = useOutletContext<RouteContextParams>()

  const { data: reportsSharePolicyData, loading: reportsSharePolicyLoading } = useQuery(
    ReadReportsSharePoliciesDocument,
    {
      variables: {
        dashboardId: dashboard?.id,
      },
      skip: !dashboard,
    }
  )

  const loading = loadingContext || reportsSharePolicyLoading

  const back: Back = {
    href: navigation.reports.dashboards.list.fullPath(),
    label: i18n.t('custom_reports.editor.back'),
  }

  return dashboard ? (
    <DashboardShow
      dashboard={dashboard}
      loading={loading}
      back={back}
      shareReportsPolicies={reportsSharePolicyData}
    />
  ) : null
}

export default DashboardShowPage
